import { ErrorMessageFromJSONTyped } from '../../generated-api';
import { ApiError } from '../api';

interface ProblemDetail {
  detail: string;
  title?: string;
}

const hasDetail = (x: unknown): x is ProblemDetail =>
  Boolean(x) && typeof x === 'object' && x !== null && 'detail' in x;

export class NetworkError extends Error {
  constructor(public originalError: unknown) {
    super('Network error: No response from server. Please check your internet connection.');
    this.name = 'NetworkError';
  }
}

export const parseError = async (err: unknown) => {
  if (!(err instanceof ApiError) || !err.response) {
    throw new NetworkError(err);
  }

  const { response, errorBody, message } = err;

  if (errorBody) {
    if (hasDetail(errorBody)) {
      const problemDetail = errorBody as ProblemDetail;
      // Keep the body: typed error codes (properties.code) must survive for callers
      throw new ApiError(
        response,
        errorBody,
        `Operation failed: ${problemDetail.detail}`,
        problemDetail.title ?? 'Error'
      );
    }

    try {
      throw ErrorMessageFromJSONTyped(errorBody, true);
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      } else {
        throw new Error(`Failed to parse error body: ${message}`, { cause: error });
      }
    }
  }

  throw new Error(message || `HTTP ${response.status}`);
};
